import cleanBeautyModule from 'assets/content/cleanBeauty';
import formulaModuleHeroDesktop from 'assets/images/productPages/d-module_2_hero.jpg';
import formulaModuleHeroMobile from 'assets/images/productPages/mt-module_2_hero.jpg';

export default {
  guarantee: 'Start your consultation today',
  soldOutNotice: 'This product is no longer available at this time.',
  waitingListNotice: 'Join the waitlist to be notified if it becomes available again.',
  formulaModule: {
    header: "A formula that couldn't exist without you",
    description:
      'Your unique hair needs and goals are addressed with a curated selection of our ever-growing list of sustainable and natural active ingredients.',
    hero: {
      imageDesktop: formulaModuleHeroDesktop,
      imageMobile: formulaModuleHeroMobile,
      alt: 'Smiling woman with long brown curls swept across face',
    },
  },
  cleanBeautyModule,
  faqModule: {
    header: 'Frequently asked questions',
  },
  productsModule: {
    headline: 'Discover more',
    skincareHeadline: 'Complete your skincare routine',
  },
};
